import { useState, useEffect } from "react";
import { GetProductNames } from 'services/dropdown/dropdown.service';
import { useSelector, useDispatch } from "react-redux";

const useItemDropdown = () => {
    const dispatch = useDispatch();
    
    const { productNameList, productNameLoading } = useSelector((state) => state.productNames);

    const [productDropdown, setProductDropdown] = useState([]);


    useEffect(() => {
        dispatch(GetProductNames());
    }, []);

    return {
        productDropdown, 
        setProductDropdown, 
        productNameList,
    };
};

export default useItemDropdown;
